(function () {
  const initSlider = () => {
    // Fix #1: querySelectorAll + :not(.slider_started) inicializa TODOS los cards
    const sliders = document.querySelectorAll(".swiper-container:not(.slider_started)");

    sliders.forEach((slider) => {
      slider.classList.add("slider_started");

      new Swiper(slider, { // Fix #2: pasar el elemento DOM, no un string global
        slidesPerView: 1,
        speed: 250,
        spaceBetween: 0,
        nested: true,                     // Fix #3a: está dentro de otro Swiper
        touchStartPreventDefault: false,  // Fix #3b: no cancela taps en móvil
        threshold: 10,                    // Fix #3c: distingue swipe vs tap
        navigation: {
          // Fix #2: scoped a este card específico, no al primero del DOM
          nextEl: slider.querySelector(".swiper-button-next-1"),
          prevEl: slider.querySelector(".swiper-button-prev-1"),
        },
        pagination: {
          el: slider.querySelector(".product-card-pagination"),
          clickable: true,
        },
      });
    });
  };

  initSlider();

  // Fix extra: el addEventListener estaba duplicado/anidado incorrectamente
  document.addEventListener("shopify:section:load", initSlider);
})();